import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { MESSAGE_MAP } from '@/config/message';
import { isValidUrl, isAlphanumeric } from '@/helpers/common';

export const usePointModal = ({ isQrScanOpened = false, constraints = {}, isUseTicketFlag = null }) => {
  const store = useStore();
  const router = useRouter();

  const pointModalShow = ref(false);
  const pointStatus = ref(false);
  const pointCode = ref(0);

  const handleClose = () => {
    pointModalShow.value = false;
    pointCode.value = 0;
    pointStatus.value = false;
    store.commit('common/RESET_QR_POINT_DATA', null);
  };

  const showPointModal = (data) => {
    pointCode.value = Number(data?.amount);
    pointStatus.value = !!data?.type;
    pointModalShow.value = true;
    getUserInfo();
  };

  const getUserInfo = async () => {
    await store.dispatch('auth/getUserInfor');
  };
  const customHandleScanSuccess = async (callback) => {
    callback();
  };
  const handleScanSuccess = async (qrId) => {
    const isCurrencyQr = JSON.parse(sessionStorage.getItem('isCurrencyQr'));
    constraints.value.faceingMode = null;
    isQrScanOpened.value = false;
    customHandleScanSuccess(async() => {
      if (!qrId || isValidUrl(qrId) || (!isCurrencyQr && !isAlphanumeric(qrId))) {
        store.dispatch('common/openErrorModal', true);
        store.dispatch('common/setErrors', [MESSAGE_MAP.invalidQrPoint]);
        return;
      }
      const action = isUseTicketFlag?.value ? 'ticket/ticketQrCode' : isCurrencyQr ? 'ticket/currencyQrCode' : 'point/payQrCode';
      const data = isUseTicketFlag?.value || isCurrencyQr ? { qrCode: qrId, checkOTP: false } : { qrPointId: qrId, checkQr: true };
      const res = await store.dispatch(action, data);
      sessionStorage.removeItem('ticketData');
      sessionStorage.removeItem('currencyData');
      sessionStorage.removeItem('qrPointItem');
      sessionStorage.removeItem('qrData');
      if (res?.status) {
        if (isUseTicketFlag?.value) {
          sessionStorage.setItem('ticketData', JSON.stringify({ ...res, qrCode: qrId }));
          if (!res?.useOTP) {
            router.push({ name: 'TicketConfirm' });
          } else {
            router.push({ name: 'TicketKeyword' });
          }
        } else {
          if (isCurrencyQr) {
            sessionStorage.setItem('currencyData', JSON.stringify({ ...res, qrCode: qrId }));
            if (!res?.useOTP) {
              router.push({ name: 'CurrencyConfirm' });
            } else {
              router.push({ name: 'CurrencyKeyword' });
            }
          } else {
            if (res?.useKeyword) {
              sessionStorage.setItem('qrPointItem', JSON.stringify({ ...res, qrCode: qrId }));
              router.push({ name: 'ChildPointKeyword' });
            } else if (res?.useOTP) {
              sessionStorage.setItem('qrPointItem', JSON.stringify({ ...res, qrCode: qrId }));
              router.push({ name: 'ChildPointOtp' });
            } else {
              await store.dispatch(action, {
                qrPointId: qrId,
                checkKeyword: true,
              });
              showPointModal(res);
            }
          }
        }
      }
    });
  };

  return {
    pointModalShow,
    pointStatus,
    pointCode,
    handleClose,
    handleScanSuccess,
    showPointModal
  };
};
